import React, { PureComponent } from 'react'
import Loader from '../../../Shared/Loader'
import {
  getBlueprint,
  getGiataProperty,
  getGiataPropertyImages,
  getPermissionsByGiataId,
  getRooms,
  uploadImage
} from '../../../../api'
import DashboardWidget from '../../DashboardWidget'
import './style.scss'
import Alert from '../../../Shared/Alert'
import OpenContentLink from '../../Property/OpenContentLink'
import PropTypes from 'prop-types'
import FlowtifyInfo from '../../Property/FlowtifyInfo'
import ImageBrowser from '../../Property/ImageBrowser'
import Queue from '../../Property/ImageBrowser/queue'
import { uploadItemStatus } from '../../Property/ImageBrowser/constants'
import { connect } from 'react-redux'
import Header from '../../Header'
import Footer from '../../../Shared/Footer'
import RoomBrowser from '../../Property/Rooms/index'
import EditProperty from '../../Property/EditProperty'
import { withRouter } from '../../../Shared/Routing/withRouter'
import { roomActions } from '../../../../redux/actions/room'
import { withTranslation } from 'react-i18next'
import history from '../../../../history'
import ActionBar from '../../Property/ImageBrowser/ActionBar'
import activityTrackingService from '../../../../services/activityTrackingService'
import * as uuid from 'uuid'
import NavigationSidebar from '../../Property/NavigationSidebar'
import { isNavigationAllowed, propertyNavRoutes } from '../../Property/NavigationSidebar/NavigationHelper'
import ChannelList from '../ChannelList'
import { isImageConfirmed } from '../../Property/ImageBrowser/utils'
import PropertyChecklist from '../../Property/CheckList'
import hotelierPropertyService from '../../../../services/hotelierPropertyService'
import { propertyActions } from '../../../../redux/actions/property'
import PropertyPublishedNoticeOverlay from '../../Property/PropertyPublishedNoticeOverlay'
import UnsavedChangesNoticeOverlay from '../../Property/EditProperty/UnsavedChangesNoticeOverlay'
import { trackingEvent } from '../../../../constants'
import ErrorNoticeOverlay from '../../ErrorNoticeOverlay'
import publishErrorImage from '../../../../assets/img/icons/info-retry.svg'

class PropertyPage extends PureComponent {

  state = {
    initialized: false,
    giataId: null,
    loading: false,
    property: null,
    permissions: null,
    rooms: null,
    roomAttributes: null,
    uploadQueue: [],
    selectedNavigation: null,
    isDirtyEditProperty: false,
    images: [],
    selectedImageIdsMap: {},
    promptUnsavedChanges: {
      show: false,
      onConfirmFunc: null
    },
    mainImage: null,
    propertyInfo: null,
    initialFactsheet: null,
    showPropertyPublishedLayer: false,
    error: false,
  }
  abortController = new AbortController()

  componentDidMount () {
    const giataId = parseInt(this.props.router.params.id, 10)
    activityTrackingService.setGiataIdForEventsAndPageViews(giataId)
    const initState = { giataId }
    if (this.props.router.params.hasOwnProperty('subPage')) {
      initState.selectedNavigation = this.getSelectedNavigationValueFromSubPage(this.props.router.params.subPage)
    }
    this.setState(initState, () => {
      this.init(true)
    })
  }

  closePropertyFailedToPublishErrorOverlay = () => {
    this.props.setPropertyFailedToPublish(false)
  }

  /**
   * This returns an unblock handler that can be later used to unblock
   * It is currently called only when the isDirty bit is set to true
   */
  blockHistory () {
    return history.block(({ retry }) => {
      if (this.state.selectedNavigation === propertyNavRoutes.editProperty && this.state.isDirtyEditProperty) {
        this.setState({
          promptUnsavedChanges: {
            show: true,
            onConfirmFunc: () => {
              this.cancelPromptUnsavedChanges(() => {
                activityTrackingService.trackEvent(trackingEvent.discardEditPropertyChanges)
                this.unblockHistory()
                retry()
              })
            }
          }
        })
        return
      }
      this.unblockHistory()
      retry()
    })
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (prevProps.router.params.subPage !== this.props.router.params.subPage) {
      this.setState({ selectedNavigation: this.getSelectedNavigationValueFromSubPage(this.props.router.params.subPage) })
    }
    if (prevProps.router.params.id !== this.props.router.params.id) {
      this.props.setPropertyHasUnpublishedChanges(false)
      this.setState({ giataId: parseInt(this.props.router.params.id, 10) }, () => {
        this.init(false)
      })
      return
    }
    if (prevProps.propertyHasUnpublishedChanges && !this.props.propertyHasUnpublishedChanges) {
      this.setState({
        showPropertyPublishedLayer: true
      })
    }
  }

  componentWillUnmount () {
    if (this.queue) {
      this.queue.clear()
    }
    this.props.setPropertyHasUnpublishedChanges(false)
    this.abortController.abort()
  }

  getSelectedNavigationValueFromSubPage (subPage) {
    if (!Object.values(propertyNavRoutes).includes(subPage)) {
      return null
    }
    return subPage
  }

  onIsDirtyEditPropertyChange = (isDirty) => {
    this.unblockHistory && this.unblockHistory()
    this.unblockHistory = isDirty ? this.blockHistory() : null
    this.setState({ isDirtyEditProperty: isDirty }, () => {
      this.updatePropertyPublishBlockedState()
    })
  }

  onImagesChange = (images) => {
    this.setState({ images, mainImage: this.getPropertyMainImage(images) }, () => {
      this.updatePropertyPublishBlockedState()
    })
  }

  onImagesDeleted = (imageIds) => {
    const images = this.state.images.filter(image => !imageIds.includes(image.id))
    const selectedImageIdsMap = Object.assign({}, this.state.selectedImageIdsMap)
    imageIds.forEach((imageId) => {
      delete selectedImageIdsMap[imageId]
    })
    this.setState({ images, selectedImageIdsMap, mainImage: this.getPropertyMainImage(images) }, () => {
      this.updatePropertyPublishBlockedState()
    })
  }

  onSelectedImageIdsMapChange = (selectedImageIdsMap) => {
    this.setState({ selectedImageIdsMap })
  }

  onCancelSelection = () => {
    this.setState({ selectedImageIdsMap: {} })
  }

  onUploadQueueChange = (uploadQueue) => {
    this.setState({ uploadQueue })
  }

  onUploadQueueImageRemove = (image) => {
    const index = this.state.uploadQueue.indexOf(image)
    if (index > -1) {
      let uploadQueueNew = [...this.state.uploadQueue]
      uploadQueueNew.splice(index, 1)
      this.onUploadQueueChange(uploadQueueNew)
    }
  }

  onRoomsChange = (rooms) => {
    this.props.putRooms(rooms)
  }

  init (initial) {
    if (!initial) {
      this.abortController.abort()
      this.abortController = new AbortController()
    }
    this.setState({ initialized: false, loading: true }, async () => {
      const concurrentApiRequests = []
      let request = getGiataProperty(this.state.giataId, this.abortController)
      concurrentApiRequests.push(request.fetchPromise)
      request = getBlueprint(this.abortController)
      concurrentApiRequests.push(request.fetchPromise)
      request = getRooms(this.state.giataId, this.abortController)
      concurrentApiRequests.push(request.fetchPromise)
      request = getPermissionsByGiataId(this.state.giataId, this.abortController)
      concurrentApiRequests.push(request.fetchPromise)
      request = getGiataPropertyImages(this.state.giataId, this.abortController)
      concurrentApiRequests.push(request.fetchPromise)

      let concurrentApiResponses
      try {
        concurrentApiResponses = await Promise.all(concurrentApiRequests)
      } catch (e) {
        if (e.message === 'NOT_AUTHORIZED') {
          this.props.router.navigate('/errors/not-authorized')
        }
        this.setState({ loading: false, error: true })
        return
      }
      const roomAttributes = concurrentApiResponses[1]
      const rooms = concurrentApiResponses[2]
      const property = concurrentApiResponses[0]
      const permissions = concurrentApiResponses[3].permissions
      const images = concurrentApiResponses[4]

      this.props.putRoomAttributes(this.buildRoomAttributesMap(roomAttributes))
      this.props.putRooms(rooms)

      const editPropertyAllowed = isNavigationAllowed(propertyNavRoutes.editProperty, permissions)

      this.queue = new Queue(1)
      const newState = {
        initialized: !editPropertyAllowed,
        loading: editPropertyAllowed,
        property,
        permissions,
        images,
        mainImage: this.getPropertyMainImage(images),
        uploadQueue: [],
        isDirtyEditProperty: false,
      }
      this.props.refreshPropertyPublishStatus(this.state.giataId)
      this.setState(newState, () => {
        if (!isNavigationAllowed(this.state.selectedNavigation, permissions)) {
          this.changeNavigation(propertyNavRoutes.editRooms, true)
        }
        this.updatePropertyPublishBlockedState()
      })
      if (editPropertyAllowed) {
        // load property info
        hotelierPropertyService.getGiataHotelierProperty(this.state.giataId, this.abortController)
          .then(res => {
            this.setState({
              propertyInfo: res.giataHotelierProperty,
              initialFactsheet: res.initialFactsheet,
              loading: false,
              initialized: true,
            })
          })
          .catch(() => {
            this.setState({ loading: false, error: true })
          })
      }
    })
  }

  updatePropertyPublishBlockedState () {
    const hasUnconfirmedImages = this.getUnConfirmedImagesCount() > 0
    if (hasUnconfirmedImages !== this.props.propertyPublishBlockedUnconfirmedImages) {
      this.props.setPropertyPublishBlockedUnconfirmedImages(hasUnconfirmedImages)
    }
  }

  buildRoomAttributesMap (roomAttributes) {
    let roomCategory = {}
    let roomName = {}
    let roomType = {}
    let roomView = {}
    roomAttributes.roomCategory.forEach((v) => {
      roomCategory[v.id] = v
    })
    roomAttributes.roomName.forEach((v) => {
      roomName[v.id] = v
    })
    roomAttributes.roomType.forEach((v) => {
      roomType[v.id] = v
    })
    roomAttributes.roomView.forEach((v) => {
      roomView[v.id] = v
    })
    return {
      roomCategory,
      roomName,
      roomType,
      roomView,
    }
  }

  getIndexOfImageInUploadQueue (image, uploadQueue) {
    return uploadQueue.findIndex(item => item.id === image.id)
  }

  /**
   * Updates the progress of an upload in the queue.
   * @param {Object} imageInUploadQueue - The image object in the upload queue.
   * @param {ProgressEvent} event - The progress event object.
   */
  updateUploadProgress = (imageInUploadQueue, event) => {
    this.setState((state) => {
      const index = this.getIndexOfImageInUploadQueue(imageInUploadQueue, state.uploadQueue)
      if (index === -1) {
        return state
      }

      const uploadQueueNew = [...state.uploadQueue]
      uploadQueueNew[index] = {
        ...uploadQueueNew[index],
        progress: Math.round((100 * event.loaded) / event.total),
      }

      return {
        uploadQueue: uploadQueueNew,
      }
    })
  }

  updateUploadStatus (imageInUploadQueue, status, cancelTokenSource) {
    this.setState((state) => {
      const index = this.getIndexOfImageInUploadQueue(imageInUploadQueue, state.uploadQueue)
      if (index === -1) {
        return state
      }

      const uploadQueueNew = [...this.state.uploadQueue]
      uploadQueueNew[index] = {
        ...uploadQueueNew[index],
        status: status,
        cancelTokenSource
      }

      return {
        uploadQueue: uploadQueueNew,
      }
    })
  }

  handleUploadError (imageInUploadQueue, error) {
    this.setState((state) => {
      const index = this.getIndexOfImageInUploadQueue(imageInUploadQueue, state.uploadQueue)
      if (index === -1) {
        return state
      }

      const uploadQueueNew = [...this.state.uploadQueue]
      let status = uploadItemStatus.error
      if (
        (error.hasOwnProperty('status') && error.status === 406)
        || (error.isAxiosError === true && error?.response?.status === 406)) {
        status = uploadItemStatus.errorProcessImage
      }
      uploadQueueNew[index] = {
        ...uploadQueueNew[index],
        status
      }
      return {
        uploadQueue: uploadQueueNew,
      }
    })
  }

  handleUploadSuccess (imageInUploadQueue, responseData) {
    this.setState((state) => {
      const index = this.getIndexOfImageInUploadQueue(imageInUploadQueue, state.uploadQueue)
      if (index === -1) {
        return state
      }
      const uploadQueueNew = [...this.state.uploadQueue]
      if (uploadQueueNew[index].progress !== 100 || !responseData.hasOwnProperty('url')) {
        uploadQueueNew[index] = {
          ...uploadQueueNew[index],
          status: uploadItemStatus.error
        }
      } else {
        let imagesNew = [...this.state.images]
        const existingImageIndex = imagesNew.findIndex(image => image.id === responseData.id)
        if (existingImageIndex !== -1) {
          imagesNew[existingImageIndex] = responseData
        } else {
          imagesNew.push(responseData)
        }
        uploadQueueNew.splice(index, 1)
        return {
          images: imagesNew,
          uploadQueue: uploadQueueNew
        }
      }

      return {
        uploadQueue: uploadQueueNew,
      }
    }, () => {
      this.updatePropertyPublishBlockedState()
    })
  }

  onUploadFiles = (files, roomId = null) => {
    let uploadQueue = [...this.state.uploadQueue]

    files.forEach((file) => {
      const uuidV4 = uuid.v4()
      file.id = uuidV4
      const previewUrl = URL.createObjectURL(file)
      const imageInUploadQueue = {
        id: uuidV4,
        src: previewUrl,
        name: file.name,
        status: uploadItemStatus.waiting,
        file: file,
        roomId,
        progress: 0,
      }
      uploadQueue.push(imageInUploadQueue)
    })

    this.setState({ uploadQueue }, () => {
      files.forEach((file) => {
        const imageInUploadQueue = this.state.uploadQueue.find(image => image.id === file.id)
        if (!imageInUploadQueue) {
          console.error(`Image with id ${file.id} not found in uploadQueue`)
          return
        }
        const taskUploadImage = async () => {
          const { promise, cancelTokenSource } = uploadImage(
            this.state.property.giataId,
            imageInUploadQueue.file,
            imageInUploadQueue.roomId,
            (event) => {
              this.updateUploadProgress(imageInUploadQueue, event)
            }
          )

          try {
            this.updateUploadStatus(imageInUploadQueue, uploadItemStatus.uploading, cancelTokenSource)
            const response = await promise
            this.handleUploadSuccess(imageInUploadQueue, response.data)
          } catch (e) {
            this.handleUploadError(imageInUploadQueue, e)
          }
        }

        this.queue.enqueue(taskUploadImage).catch(console.error)
      })
    })
  }

  cancelPromptUnsavedChanges = (cb) => {
    this.setState(
      {
        promptUnsavedChanges: {
          show: false,
          onConfirmFunc: null
        }
      },
      typeof (cb) === 'function' ? cb : null
    )
  }

  onSelectedNavBarChange = (route) => {
    history.push(route)
  }

  changeNavigation (selectedNavigation, replace = false) {
    if (Object.values(propertyNavRoutes).includes(selectedNavigation)) {
      const path = '/property/' + this.state.giataId + '/' + selectedNavigation
      if (replace) {
        history.replace(path)
      }
      history.push(path)
    }
  }

  showImageBrowserSaveButton = () => {
    if (/^giata-\d+-supplier-\d+@giata.de$/.test(this.props.user.user)) {
      return false
    }
    return true
  }

  getConfirmedImagesCount = () => {
    return this.state.images.filter(image => isImageConfirmed(image)).length
  }

  getUnConfirmedImagesCount = () => {
    return this.state.images.filter(image => !isImageConfirmed(image)).length
  }

  getPropertyMainImage = (images = []) => {
    const heroImage = images.find(i => i.hero === true)
    return heroImage ? heroImage.displayUrl : (images[0]?.displayUrl ?? null)
  }

  getNavigationContent () {
    let navigationContent = null
    if (this.state.selectedNavigation === propertyNavRoutes.dashboard) {
      navigationContent =
        <DashboardWidget trackPageViewName={'Dashboard'} giataId={this.state.giataId} widget={'scores'}
                         permissions={this.state.permissions}
                         confirmedImagesCount={this.getConfirmedImagesCount()}/>
    } else if (this.state.selectedNavigation === propertyNavRoutes.distribution) {
      navigationContent =
        <DashboardWidget
          trackPageViewName={'Sales Channels'}
          giataId={this.state.giataId}
          widget={'distribution'}
          permissions={this.state.permissions}
          propertyImage={this.state.mainImage}
        />
    } else if (this.state.selectedNavigation === propertyNavRoutes.tourOperators) {
      navigationContent =
        <DashboardWidget
          trackPageViewName={'Tour Operators'}
          giataId={this.state.giataId} widget={'tourOperators'}
          permissions={this.state.permissions}
          propertyImage={this.state.mainImage}
        />
    } else if (this.state.selectedNavigation === propertyNavRoutes.compare) {
      navigationContent =
        <DashboardWidget
          trackPageViewName={'Compare Hotels'}
          giataId={this.state.giataId}
          widget={'compare'}
          permissions={this.state.permissions}
          propertyImage={this.state.mainImage}
        />
    } else if (this.state.selectedNavigation === propertyNavRoutes.editProperty) {
      navigationContent = this.state.propertyInfo === null
        ? <Loader size={32}/>
        : <EditProperty
          giataId={this.state.giataId}
          permissions={this.state.permissions}
          onIsDirtyChange={this.onIsDirtyEditPropertyChange}
          propertyInfo={this.state.propertyInfo}
          initialFactsheet={this.state.initialFactsheet}
          updatePropertyInfo={propertyInfo => {
            this.setState({
              propertyInfo
            })
          }}
        />
    } else if (this.state.selectedNavigation === propertyNavRoutes.editRooms) {
      navigationContent =
        <RoomBrowser property={this.state.property}
                     rooms={this.props.room.rooms}
                     images={this.state.images}
                     roomAttributes={this.props.room.roomAttributes}
                     onRoomsChange={this.onRoomsChange}
                     onImagesChange={this.onImagesChange}
                     uploadQueue={this.state.uploadQueue}
                     onUploadFiles={this.onUploadFiles}
                     onUploadQueueImageRemove={this.onUploadQueueImageRemove}/>
    } else if (this.state.selectedNavigation === propertyNavRoutes.ocl) {
      navigationContent = <OpenContentLink property={this.state.property}/>
    } else if (this.state.selectedNavigation === propertyNavRoutes.staySafe) {
      navigationContent = <FlowtifyInfo permissions={this.state.permissions} giataId={this.state.property.giataId}/>
    } else if (this.state.selectedNavigation === propertyNavRoutes.images) {
      navigationContent =
        <ImageBrowser images={this.state.images} property={this.state.property}
                      onImagesChange={this.onImagesChange}
                      user={this.props.user}
                      rooms={this.props.room.rooms}
                      showSaveButton={this.showImageBrowserSaveButton()}
                      roomAttributes={this.props.room.roomAttributes}
                      permissions={this.state.permissions}
                      uploadQueue={this.state.uploadQueue}
                      onUploadFiles={this.onUploadFiles}
                      onUploadQueueChange={this.onUploadQueueChange}
                      selectedImageIdsMap={this.state.selectedImageIdsMap}
                      onSelectedImageIdsMapChange={this.onSelectedImageIdsMapChange}
        />
    } else if (this.state.selectedNavigation === propertyNavRoutes.channelList) {
      navigationContent = <ChannelList/>
    }
    return navigationContent
  }

  render () {
    const isImagesView = this.state.selectedNavigation === propertyNavRoutes.images
    let imagesActionBar = null
    if (isImagesView) {
      const selectedImages = this.state.images.filter(item => this.state.selectedImageIdsMap[item.id])
      const selectedImagesCount = selectedImages.length
      imagesActionBar = selectedImagesCount > 0 && <ActionBar
        giataId={this.state.giataId}
        selectedImages={selectedImages}
        onCancelClick={this.onCancelSelection}
        onImagesDeleted={this.onImagesDeleted}
      />
    }

    return (
      <div className="default-layout main-wrapper">
        <Header property={this.state.property}/>
        <main>
          <NavigationSidebar
            property={this.state.property}
            permissions={this.state.permissions}
            onNavigate={this.onSelectedNavBarChange}
          />
          <div className="property-page">
            {this.state.loading && <Loader size={16}/>}
            {this.state.error && <Alert type={'danger'}>Error occurred</Alert>}
            {
              this.props.propertyFailedToPublish && <ErrorNoticeOverlay
                onClose={this.closePropertyFailedToPublishErrorOverlay}
                header={this.props.t('ERROR_NOTICE_PROPERTY_PUBLISH_HEADER')}
                icon={publishErrorImage}
              />
            }
            {
              this.state.initialized === true ? <React.Fragment>
                  {imagesActionBar}
                  <div className="property-page-nav-content" style={{ marginTop: imagesActionBar && '-35px' }}>
                    {this.getNavigationContent()}
                  </div>
                  {
                    this.state.promptUnsavedChanges.show && <UnsavedChangesNoticeOverlay
                      onCancel={() => {
                        this.cancelPromptUnsavedChanges()
                      }}
                      onConfirm={this.state.promptUnsavedChanges.onConfirmFunc}
                    />
                  }
                  <PropertyChecklist
                    ready={this.state.initialized}
                    property={this.state.propertyInfo}
                    images={this.state.images}
                    rooms={this.props.room.rooms}
                    includeEditPropertyItems={isNavigationAllowed(propertyNavRoutes.editProperty, this.state.permissions)}
                  />
                  {this.state.showPropertyPublishedLayer && <PropertyPublishedNoticeOverlay
                    giataId={this.state.giataId}
                    onClose={() => {
                      this.setState({ showPropertyPublishedLayer: false })
                    }}
                  />}
                </React.Fragment>
                : null
            }
          </div>
        </main>
        <Footer/>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    room: state.room,
    propertyHasUnpublishedChanges: state.property.hasUnpublishedChanges,
    propertyFailedToPublish: state.property.failedToPublish,
    propertyPublishBlockedUnconfirmedImages: state.property.isPublishBlockedDueToUnconfirmedImages
  }
}

const mapDispatchToProps = {
  putRooms: roomActions.putRooms,
  putRoomAttributes: roomActions.putRoomAttributes,
  refreshPropertyPublishStatus: propertyActions.refreshPublishStatus,
  setPropertyHasUnpublishedChanges: propertyActions.setHasUnpublishedChanges,
  setPropertyPublishBlockedUnconfirmedImages: propertyActions.setIsPublishBlockedDueToUnconfirmedImages,
  setPropertyFailedToPublish: propertyActions.setFailedToPublish,
}

PropertyPage.propTypes = {
  user: PropTypes.object,
  router: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(withRouter(PropertyPage)))
